import * as types from "../types/CleaningTypes";
import PriceCalc from "../utilities/priceCalculator";
import moment from "moment";
const CleaningReducerInitialState = {
  frequency: "twoWeeks",
  bedrooms: 1,
  bathrooms: 1,
  addons: {
    oven: false,
    fridge: false,
    deepClean: false,
    windows: false,
    walls: false,
    moveOut: false,
    laundry: false,
    cabinets: false
  },
  price: PriceCalc("twoWeeks", 1, 1, {}, 0),
  discount: 0,
  date: moment().add(2, "days"),
  time: "1 PM",
  booked: false
};
export const CleaningReducer = (
  state = CleaningReducerInitialState,
  action
) => {
  switch (action.type) {
    case types.UPDATE_BATHROOMS:
      return {
        ...state,
        bathrooms: action.payload,
        price: PriceCalc(
          state.frequency,
          state.bedrooms,
          action.payload,
          state.addons,
          state.discount
        )
      };
    case types.UPDATE_BEDROOMS:
      return {
        ...state,
        bedrooms: action.payload,
        price: PriceCalc(
          state.frequency,
          action.payload,
          state.bathrooms,
          state.addons,
          state.discount
        )
      };
    case types.UPDATE_FREQUENCY:
      return {
        ...state,
        frequency: action.payload,
        price: PriceCalc(
          action.payload,
          state.bedrooms,
          state.bathrooms,
          state.addons,
          state.discount
        )
      };
    case types.UPDATE_DATE:
      return {
        ...state,
        date: moment(action.payload)
      };
    case types.UPDATE_TIME:
      return {
        ...state,
        time: action.payload
      };
    case types.CLEANING_SUCCESS:
      return {
        ...state,
        ...action.payload,
        booked: true,
        price: PriceCalc(
          action.payload.frequency,
          action.payload.bedrooms,
          action.payload.bathrooms,
          {},
          0
        )
      };
    case types.TOGGLE_ADDON:
      const key = action.payload;
      const returnObj = {
        ...state
      };
      returnObj.addons[key] = !state.addons[key];
      returnObj.price = PriceCalc(
        state.frequency,
        state.bedrooms,
        state.bathrooms,
        returnObj.addons,
        state.discount
      );
      return returnObj;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/CleaningReducer.js